import type { UpdateConversation200LastMessageRole } from './updateConversation200LastMessageRole';

/**
 * AI 채팅 대화 요약 정보
 */
export type UpdateConversation200 = {
  /** 생성 시간 */
  createdAt: string;
  /** 대화 ID */
  id: string;
  /**
   * 마지막 메시지 생성 시각
   * @nullable
   */
  lastMessageAt?: string | null;
  /**
   * 마지막 메시지 미리보기 (80자 이내)
   * @nullable
   */
  lastMessagePreview?: string | null;
  /**
   * 마지막 메시지 역할
   * @nullable
   */
  lastMessageRole?: UpdateConversation200LastMessageRole;
  /**
   * 저장된 메시지 개수
   * @nullable
   */
  messageCount?: number | null;
  /**
   * 기본 사용 모델
   * @nullable
   */
  model?: string | null;
  /**
   * 대화 제목
   * @nullable
   */
  title?: string | null;
  /**
   * 대화에서 사용된 총 토큰 수
   * @nullable
   */
  totalTokens?: number | null;
  /** 최근 업데이트 시간 */
  updatedAt: string;
  /** 사용자 ID */
  userId: string;
};
